import React, { useCallback, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import styles from './Login.module.css';
import { QrCode } from '../../../component/parentPortal/qrCode';
import {
  AppStateAuthentication,
  updateAppAuthentication,
} from '../../../store/reducer/appStateSlice';
import { outsideComponentDispatch } from '../../../store/store';
import { LoginElement } from '../LoginElement';

export const DesktopView = (): JSX.Element => {
  // Redux Hooks

  const loginElement = LoginElement();

  return (
    <React.Fragment>
      <Box className={styles.desktopMainPage}>
        <Box className={styles.desktopLeftImageFrameBox}>
          <Box className={styles.desktopHeaderIconBox}>
            <img
              className={styles.desktopHeaderIcon}
              id="desktop-header"
              alt=""
              src="assets/common/bba-logo.svg"
            />
          </Box>
          <img
            src="assets/login/login-bg-min.png"
            className={styles.leftBackground}
          />
          <Box className={styles.desktopLeftImage}>
            <img
              id="login-image"
              alt=""
              src={
                loginElement.loginMode === 'bbl'
                  ? 'assets/login/desktop-left-side-section-bbl.png'
                  : 'assets/login/desktop-left-side-section-pp.png'
              }
            />
          </Box>
          <Box className={styles.rightMainGroupWrapper}>
            <Box className={styles.desktopRightMainGroup}>
              <Box className={styles.mainGroupBox}>
                <Box className={styles.mainGroupLeftContentBox}>
                  <span className={styles.titleText}>Welcome Back</span>
                  <span className={styles.descriptionText}>
                    Enter your details to login.
                  </span>
                </Box>
                <Box className={styles.divider} />
                {loginElement.loginModeSelection(100)}

                {loginElement.loginMode === 'bbl' && (
                  <>
                    <Box className={styles.mainGroupLeftContentBox}>
                      {loginElement.emailInput}
                      {/* <b
                      className={styles.forgetButton}
                      onClick={loginElement.forgetEmailButtonClickHandler}
                    >
                      Forgot Email?
                    </b> */}
                      {loginElement.passwordInput}
                      <Box className={styles.optionsBox}>
                        {loginElement.rememberMeCheckbox}{' '}
                        <b
                          className={styles.forgetButton}
                          onClick={
                            loginElement.forgetPasswordButtonClickHandler
                          }
                        >
                          Need Help?
                        </b>
                      </Box>
                    </Box>
                    {loginElement.loginButton}
                  </>
                )}
                {loginElement.loginMode === 'parentPortal' && (
                  <>
                    <Box className={styles.qrCodeBox}>
                      <QrCode url="https://start.bigbanglab.app/Login" />
                      <span>
                        The Parent Portal is only avaliable on mobile, please
                        scan the QR code to login.
                      </span>
                    </Box>
                    <Button
                      variant="contained"
                      sx={{ width: '100%', ':disabled': { color: '#949494' } }}
                      fullWidth={true}
                      disabled
                    >
                      Login on mobile
                    </Button>
                  </>
                )}
                <Box className={styles.mainGroupLeftContentBox}>
                  <Box className={styles.mainGroupContentInlineBox}>
                    <span id="login-main-group-sign-up-text">
                      Don’t have an account?
                    </span>
                    <b
                      className={styles.signUpB}
                      onClick={() => {
                        loginElement.signUpRedirectButtonClickHandler();
                      }}
                    >
                      Sign up
                    </b>
                    <span className={styles.span}>.</span>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};
